const editableFields = [
  ['fecha', 'Fecha'],
  ['idAlmacen', 'Almacen'],
  ['idVariedad', 'Variedad'],
  ['kilos', 'Kilos entrada'],
  ['crucesPalots', 'Grupos de 4 palots'],
  ['kilosPalot', 'Peso del palot'],
  ['pesoCaja', 'Peso caja'],
  ['otrosCalibres', 'Precalibrado (kg)'],
  ['pOtrosCalibres', 'Precalibrado (palots)'],
  ['retorno', 'Retorno (kg)'],
  ['pRetorno', 'Retorno (palots)'],
  ['verde', 'Verde (kg)'],
  ['pVerde', 'Verde (palots)'],
  ['segunda', 'Segunda (kg)'],
  ['pSegunda', 'Segunda (palots)'],
  ['bajoCalibre', 'Bajo calibre (kg)'],
  ['pBajoCalibre', 'Bajo calibre (palots)'],
  ['industria', 'Industria (kg)'],
  ['pIndustria', 'Industria (palots)'],
  ['podrido', 'Podrido (kg)'],
  ['observaciones', 'Observaciones'],
];

const numericFields = new Set(editableFields.map(([key]) => key).filter(
  (key) => !['fecha', 'idVariedad', 'observaciones'].includes(key)
));

export const toEditableEntrada = (entrada, pesosPalot = [], pesosCaja = []) => {
  const pesoPalot = pesosPalot.find((item) =>
    item.id === Number(entrada.idPesoPalot)
  );
  const caja = pesosCaja.find((item) =>
    item.id === Number(entrada.idPesoCaja)
  );

  return {
    ...entrada,
    idVariedad: String(entrada.idVariedad || ''),
    idPesoPalot: entrada.idPesoPalot ?? null,
    kilosPalot: entrada.idPesoPalot == null ? '' : entrada.kilosPalot || pesoPalot?.peso || '',
    idPesoCaja: entrada.idPesoCaja ?? null,
    pesoCaja: entrada.idPesoCaja == null ? '' : entrada.pesoCaja || caja?.peso || '',
    paletsEntrada: { ...entrada.paletsEntrada },
  };
};

export const buildEntradaUpdatePayload = (payload, version, reason) => {
  const motivo = reason.trim();
  if (!Number.isInteger(version) || version < 1) {
    throw new Error('La version de la entrada no es valida.');
  }
  if (!motivo || motivo.length > 2000) {
    throw new Error('El motivo del cambio debe tener entre 1 y 2000 caracteres.');
  }

  return { ...payload, version, motivo_cambio: motivo };
};

export const getEntradaChanges = (original, current, cajasPalet = [], almacenes = [], variedades = []) => {
  const changes = editableFields.flatMap(([key, label]) => {
    const before = original[key] ?? '';
    const after = current[key] ?? '';
    const normalizedBefore = numericFields.has(key) ? Number(before) || 0 : String(before);
    const normalizedAfter = numericFields.has(key) ? Number(after) || 0 : String(after);

    if (normalizedBefore === normalizedAfter) return [];

    const display = (value) => {
      if (key === 'idAlmacen') return almacenes.find((item) => item.id === Number(value))?.nombre || String(value);
      if (key === 'idVariedad') return variedades.find((item) => item.id === String(value))?.nombre || String(value);
      return String(value);
    };

    return [{ key, label, before: display(before), after: display(after) }];
  });

  const paletIds = new Set([
    ...Object.keys(original.paletsEntrada || {}),
    ...Object.keys(current.paletsEntrada || {}),
  ]);

  paletIds.forEach((id) => {
    const before = Number(original.paletsEntrada?.[id]) || 0;
    const after = Number(current.paletsEntrada?.[id]) || 0;
    if (before === after) return;

    const caja = cajasPalet.find((item) => String(item.id) === id);
    changes.push({
      key: `palet-${id}`,
      label: caja ? `Palets de ${caja.cajas} cajas` : `Palets #${id}`,
      before: String(before),
      after: String(after),
    });
  });

  return changes;
};
